import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Row,
  Col,
  Input,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import CommonTable from "components/CommonComponents/ReactTable/Table";
import {
  DEFAULT_RECORDS_PER_PAGE,
} from "constants/CommonConstants";

// static data
const enrolledStudentsList = [
  {
    id: 1,
    enrollmentId: "ENR-1001",
    studentName: "Rahul Sharma",
    email: "rahul.sharma@gmail.com",
    mobile: "9876543210",
    batchName: "Batch A - Jan 2026",
    enrollmentType: "Individual",
    paymentStatus: "Paid",
    enrollmentStatus: "Active",
    enrolledOn: "07 June 2026 01:06 PM",
  },
  {
    id: 2,
    enrollmentId: "ENR-1002",
    studentName: "Priya Verma",
    email: "priya.verma@gmail.com",
    mobile: "9123456780",
    batchName: "Batch A - Jan 2026",
    enrollmentType: "Corporate",
    paymentStatus: "Paid",
    enrollmentStatus: "Active",
    enrolledOn: "07 Oct 2026 01:06 PM",
  },
  {
    id: 3,
    enrollmentId: "ENR-1003",
    studentName: "Karan Sharma",
    email: "karan@gmail.com",
    mobile: "9123456780",
    batchName: "Batch B - Jan 2026",
    enrollmentType: "Individual",
    paymentStatus: "Paid",
    enrollmentStatus: "Active",
    enrolledOn: "07 March 2026 01:06 PM",
  },
];

const batchList = [
  { ID: 1, name: "Batch A - Jan 2026", courseId: 5 },
  { ID: 2, name: "Batch B - Feb 2026", courseId: 5 },
  { ID: 3, name: "Batch C - Mar 2026", courseId: 5 },

  { ID: 4, name: "Batch A - Jan 2026", courseId: 1 },
  { ID: 5, name: "Batch B - Feb 2026", courseId: 1 },

  { ID: 6, name: "Batch A - Feb 2026", courseId: 2 },
  { ID: 7, name: "Batch B - Mar 2026", courseId: 2 },

  { ID: 8, name: "Batch A - Jan 2026", courseId: 3 },
  { ID: 9, name: "Batch B - Feb 2026", courseId: 3 },

  { ID: 10, name: "Batch A - Mar 2026", courseId: 4 },
];

const EnrolledStudentsTab = ({
  courseName,
  trainerName,
  courseLevel,
  courseType,
}) => {
  const navigate = useNavigate();
  const [pageNum, setPageNum] = useState(1);
  const [filterState, setFilterState] = useState({
    searchName: "",
    searchBatch: null,
    searchStatus: null,
    filterParams: [],
  });

  const columns = [
    { Header: "Sr. No.", accessor: "id" },
    { Header: "Enrollment ID", accessor: "enrollmentId" },
    { Header: "Name", accessor: "studentName" },
    { Header: "Email", accessor: "email", Cell: ({ value }) => value || "N/A" },
    { Header: "Mobile No", accessor: "mobile" },
    {
      Header: "Enrolled On",
      accessor: "enrolledOn",
    },
    // {
    //   Header: "Actions",
    //   disableSortBy: true,
    //   Cell: ({ row }) => {
    //     const id = row.original.id;
    //     return (
    //       <div className="d-flex gap-2">
    //         <Button
    //           className="btn-link p-0"
    //           size="sm"
    //           id={`view${id}`}
    //           onClick={() => navigate(`/admin/student-details/${id}`)}
    //         >
    //           <i className="fas fa-eye" />
    //         </Button>
    //         <UncontrolledTooltip target={`view${id}`}>View</UncontrolledTooltip>
    //       </div>
    //     );
    //   },
    // },
  ];

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  const handleSearch = () => {};

  const handleClear = () => {
    setFilterState({
      searchName: "",
      searchBatch: "",
      searchStatus: null,
      filterParams: [],
    });
    if (pageNum !== 1) setPageNum(1);
  };

  const CourseInfoRow = ({ iconClass, label, value, iconExtraClass = "" }) => {
    if (!value && value !== 0) return null; // skip empty values
    return (
      <div className=" d-flex align-items-center mt-1">
        <i className={`${iconClass} mr-2 text-muted ${iconExtraClass}`} />
        <span className="mr-1 text-sm text-muted">{label} :</span>
        <strong className="text-sm">{value}</strong>
      </div>
    );
  };

  return (
    <Card>
      <CardHeader>
        <h4 className="mb-0">Enrolled Students</h4>
      </CardHeader>

      <CardBody>
        <div className="mt-auto mb-4 border-to">
          <Row>
            <Col md="4">
              <CourseInfoRow
                // iconClass="ni ni-hat-3"
                label="Course Name"
                value={courseName}
              />
              <CourseInfoRow
                // iconClass="fa-solid fa-chart-simple"
                label="Level"
                value={courseLevel}
              />
            </Col>
            <Col md="3">
              <CourseInfoRow
                // iconClass="fa fa-user-tie"
                label="Instructor"
                value={trainerName}
              />
              <CourseInfoRow
                // iconClass="fa fa-video"
                label="Course Type"
                value={courseType}
              />
            </Col>
            <Col md="3" className="mt-4">
              {courseType === "Live" && (
                <CourseInfoRow
                  // iconClass="fa fa-video"
                  label="Course Mode"
                  value={"Online"}
                />
              )}
            </Col>
          </Row>
        </div>

        <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap flex-column flex-md-row">
          {/* Left side - Filter Inputs + Search */}
          <div className="d-flex flex-wrap align-items-center filter-group ">
            <Input
              placeholder="Search by enrollment no"
              className="mr-2 mb-2 filter-select"
            />
            <Input
              placeholder="Search by name"
              className="mr-2 mb-2 filter-select"
            />
            <Input
              placeholder="Search by email"
              className="mr-2 mb-2 filter-select"
            />
            <Input
              placeholder="Search by mobile no"
              className="mr-2 mb-2 filter-select"
            />

            <div className="d-flex mr-2 mb-2 align-items-center date-range-wrapper">
              <span className="mr-2">From</span>
              <Input type="date" className="mr-1 mb-1 filter-select" />
              <span className="mx-1">To</span>
              <Input type="date" className="ml-1 mb-1 filter-select" />
            </div>

            <Button
              color="default"
              className="d-flex align-items-center mb-2 filter-btn btn-deep-blue"
              onClick={handleSearch}
            >
              <i className="fa fa-search mr-1" />
              Search
            </Button>

            {Object.keys(filterState.filterParams).length > 0 && (
              <Button
                color="default"
                className="ml-2 mb-0 filter-btn btn-simple"
                onClick={handleClear}
              >
                <i className="fa fa-times mr-1" /> Clear
              </Button>
            )}
          </div>
        </div>

        <div className="mt-2 mb-3 mx-1">
          {enrolledStudentsList.length ? (
            <span className="total-records">
              Total Records : {enrolledStudentsList.length}
            </span>
          ) : null}
        </div>

        <CommonTable
          columns={columns}
          data={enrolledStudentsList.slice(
            (pageNum - 1) * DEFAULT_RECORDS_PER_PAGE,
            pageNum * DEFAULT_RECORDS_PER_PAGE,
          )}
          defaultPageSize={DEFAULT_RECORDS_PER_PAGE}
          activePage={pageNum}
          setPageNum={setPageNum}
          totalPages={Math.ceil(
            enrolledStudentsList.length / DEFAULT_RECORDS_PER_PAGE,
          )}
          showPaginationBottom
        />
      </CardBody>
    </Card>
  );
};

export default EnrolledStudentsTab;
